import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCallDetailsRequest } from 'src/app/state/actions';
import { ApplicationState } from 'src/app/state/reducers';
import { OnDestroyHookDirective } from '../../common/hooks';
import { selectCallDetails } from 'src/app/state/selectors/call-details.selectors';
import {
  getBufferedArrayFor,
  saveDocument,
} from '../../services/save-document.service';
import { EnvironmentService, TranslationService } from '@dch/ng-common';

export type IOdbUsageLevelFourTableHeaderEvents =
  IODBLevelFourUsageTableColumnId[];

export type IODBLevelFourUsageTableColumnId =
  | 'destination'
  | 'datetime'
  | 'durationOrVolume'
  | 'price';

@Component({
  selector: 'my-bill-odb-usage-level-four-table-header',
  templateUrl: './odb-usage-level-four-table-header.component.html',
  standalone: false,
})
export class OdbUsageLevelFourTableHeaderComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() shouldShowDurationColumn? = false;
  @Input() shouldShowDestinationColumn = false;
  @Input() hasDurationTypeInSec: boolean;
  @Input() billingAccountNumber: string;
  @Input() documentReference: string;
  @Output() selectedColumns: EventEmitter<IOdbUsageLevelFourTableHeaderEvents> =
    new EventEmitter();
  @Output() downloadCSVError: EventEmitter<boolean> = new EventEmitter();

  checkboxes: { [key in IODBLevelFourUsageTableColumnId]: boolean } = {
    destination: false,
    datetime: true,
    durationOrVolume: true,
    price: true,
  };
  // price is excluded as it is disabled and not sent in the event when drag and drop happens
  currentColumnOrder: IODBLevelFourUsageTableColumnId[] = ['datetime'];

  showReorderColumnsModal: boolean = false;

  constructor(
    private store: Store<ApplicationState>,
    private environmentService: EnvironmentService,
    private translationService: TranslationService
  ) {
    super();
  }
  ngOnInit(): void {
    // set the initial columns
    if (this.shouldShowDestinationColumn) {
      this.checkboxes.destination = true;
      this.currentColumnOrder.push('destination');
    }
    if (this.shouldShowDurationColumn) {
      if (this.shouldShowDestinationColumn === false) {
        this.checkboxes.durationOrVolume = true;
      }
      this.currentColumnOrder.push('durationOrVolume');
    }
    this.outputSelectedColumns();
  }

  openReorderColumnsModal() {
    this.showReorderColumnsModal = true;
  }

  handleReorder(event: IODBLevelFourUsageTableColumnId[]) {
    this.currentColumnOrder = event;
    this.outputSelectedColumns();
  }

  handleCheckboxChange() {
    this.outputSelectedColumns();
  }

  private outputSelectedColumns() {
    this.selectedColumns.emit(
      this.currentColumnOrder
        .filter((id) => this.checkboxes[id])
        .concat('price')
    );
  }

  onHideReorderColumnsModal() {
    this.showReorderColumnsModal = false;
  }

  downloadCsv() {
    this.store.dispatch(
      getCallDetailsRequest({
        billingAccountNumber: this.billingAccountNumber,
        documentId: this.documentReference,
      })
    );
    this.addSubscription(
      this.store.select(selectCallDetails).subscribe((callDetails) => {
        if (callDetails.hasError) {
          this.downloadCSVError.emit(true);
        }

        if (callDetails.callDetails !== null) {
          if (
            this.environmentService.isProximusPlusMobileApp ||
            this.environmentService.isMobile
          ) {
            if (
              this.translationService.getTranslatedValueFor(
                'bills.cover.isAndroidWebviewPdfViewActive'
              ) === 'true'
            ) {
              //@ts-ignore
              window?.mypx?.downloadFile?.(
                window.location.origin + callDetails.entityUrl
              );
            } else {
              const link = document.createElement('a');
              link.href = callDetails.entityUrl;
              const fileName = this.documentReference + '.csv';
              link.download = fileName;
              link.click();
            }
          } else {
            saveDocument(
              getBufferedArrayFor(callDetails.callDetails),
              this.documentReference + '.csv',
              'text/csv'
            );
          }
          this.downloadCSVError.emit(false);
        }
      })
    );
  }
}
